
import React from 'react'
import Header from '../Header/header'

function HeroSection() {
  return (
    <div className='w-full flex flex-col max-w-[400px] justify-center items-center gap-3 pb-2 mt-3'>
        {/* <img src='/assets/img/Footer logo.png' alt='digitmoney logo' loading='lazy' className='w-[142px] h-[24px]'/> */}
        
        <img src='/assets/img/Group 307 (1).png' loading='lazy' className=' w-[255px] h-[75px]'/>
        
        <img src="/assets/img/Img_Hero_text.png" loading="lazy" style={{ paddingTop: "15px" }} />
      
    </div>
  )
}

export default HeroSection
